import _ from "lodash";
import DOMPurify from "dompurify";

export const createMarkup = DOMPurify.sanitize;

export const extractFormsyProps = function (props) {
    //Ensures the react-known-prop error does not get thrown on descendent elements of a formsy element //

    const {
        validations,
        setValidations,
        setValue,
        resetValue,
        getValue,
        hasValue,
        getErrorMessage,
        getErrorMessages,
        isFormDisabled,
        isValid,
        isPristine,
        isFormSubmitted,
        isRequired,
        showRequired,
        showError,
        isValidValue,
        validationError,
        validationErrors,
        primary,
        ...rest
    } = props;

    return rest;
};

export const triggerResize = function () {
    if (document.createEvent) {
        const ev = document.createEvent("Event");
        ev.initEvent("resize", true, true);
        window.dispatchEvent(ev);
    } else {
        document.fireEvent("onresize");
    }
};

/**
 * Calculate Lowest Common Multiplier for 2 numbers
 * @param {number} a - positive number
 * @param {number} b - positive number
 * @return {number} LCM
 */
export function LCM(a, b) {
    const gcd = (a, b) => (!b ? a : gcd(b, a % b));
    return (a * b) / gcd(a, b);
}

/**
 * Calculates LCM of multipliers greater then some n.
 * @param {number} n - positive number
 * @param {Array<number>} multipliers - list of numbers
 * @return {number} result number
 */
export function getMinMultipleOf(n, multipliers) {
    const multiple = _.reduce(multipliers, LCM);
    return multiple ? _.ceil(n / multiple) * multiple : n;
}

/**
 * Emit click on element, should be compatible with all current browsers / mobile
 * @param {Element} e - element
 */
export function emitClick(e, isTouchDevice) {
    const eventType = isTouchDevice ? "tap" : "click";
    if (typeof MouseEvent === "function") {
        // The standard
        const event = new MouseEvent(eventType, {
            view: window,
            bubbles: true,
            cancelable: true,
        });
        e.dispatchEvent(event);
    } else if (document.createEvent) {
        // deprecated way, thanks IE
        const event = document.createEvent("MouseEvents");
        event.initEvent(eventType, true, false);
        e.dispatchEvent(event);
    } else if (document.createEventObject) {
        // even older IE
        e.fireEvent("onclick");
    }
}
